import abo from '../../fields/shared/abo';

export const QUERY_GET_ALL_PROFILES = /* GraphQL */ `
	query(
		$limit: Float
		$offset: Float
		$filter: ProfileFilter
		$notEqual: ProfileUpdate
		$sortBy: SortBy
	) {
		getAllProfile(
			limit: $limit
			offset: $offset
			filter: $filter
			notEqual: $notEqual
			sortBy: $sortBy
		) {
			items {
				created
				id
				firstName
				lastName
				user {
					sub
					email
					phone_number
					username
				}
				rentalObjects {
					id
					address {
						firstName
						lastName
						streetName
						houseNumber
						apartmentNumber
						postalCode
						city
						district
						country
					}
				}
				abos {
					 ${abo}
				}
				getCurrentAbo {
       				 ${abo}
   				}
			}
			total
		}
	}
`;
